import React from 'react';
import ResponsiveEditor from './FormulaManager/ResponsiveEditor';
import Feedback from './Feedback';
import NormalIcon from '../StockItems/NormalIcon';
import SharingStatus from './SharingStatus';
import AskToSignInPage from '../AskToSignInPage';
import AddCredits from './AddCredits';
import FunctionDetails from './FunctionDetails';
import SrcSelector from './SrcSelector';
import ElementSelector from './ElementSelector';
import SelectTemplates from './SelectTemplates';
import PagePopUpSelector from './PagePopUpSelector';
import CategorySelector from './CategorySelector';
import GuideScreen from './GuideScreen';
import UserTable from './UserTable';
import SelectExistingContracts from './SelectExistingContracts';

export default function App(props) {

  
  var width = props.width;
  var height = props.height;

  var aScreen = props.aScreen;
  var clickBack = props.clickBack;
  var currentList = props.currentList;
  var organicChanges = props.organicChanges;
  var userNos = props.userNos;
  var userID = props.userID;

  var signKey = props.signKey;
  var sessionID = props.sessionID;
  var addToExtraScreen = props.addToExtraScreen;
  var reallySignIn = props.reallySignIn;
  var randomCode = props.randomCode;
  var programSetID = props.programSetID;
  
  var whichPopup = props.whichPopup;
  var responseGoogleYes = props.responseGoogleYes;
  var updateFns = props.updateFns;
  var logInState = props.logInState;
  var nosCredits = props.nosCredits;
  var selectNew = props.selectNew;
  var setNosCredits = props.setNosCredits;
  var setItemEdited = props.setItemEdited;
  var doingWhat = props.doingWhat;
  var setDoingWhat = props.setDoingWhat;
  var setIsClickingOnContentDiv = props.setIsClickingOnContentDiv;
  var refObject = props.refObject;
  var setIsShowingSomeDropDown = props.setIsShowingSomeDropDown;
  var overflowY = 'auto';
  var hidePanelRelativeItems = props.hidePanelRelativeItems;
  var setHidePanelRelativeItems = props.setHidePanelRelativeItems;
  var setAccessLevel = props.setAccessLevel;
  var centerZoom = props.centerZoom;
  var setTempAddr = props.setTempAddr;
  var chains = props.chains;
  var changeTab = props.changeTab;
  var palette = props.palette;
  var itemCategories = props.itemCategories;
  
  var colorCombo = props.colorCombo;
  var setColorCombo = props.setColorCombo;
  var customColorRecord = props.customColorRecord;
  var setCustomColorRecord = props.setCustomColorRecord;
  var isShowingCustom = props.isShowingCustom;
  var setIsShowingCustom = props.setIsShowingCustom;

  const popUpStyle = {
    position:'fixed',
    left: '0px',
    top:'0px', 
    // right: '0px',
    // bottom:'0px', 
    width, 
    height,
    backgroundColor:'rgba(1,1,1,0.8)',
    verticalAlign:'middle',
    zIndex:1500,
  }

  var logInScreen;
  var title;

  var heightUsed = height * 0.9;
  var padding = '20px';

  if (aScreen.t === 'feedback'){
    title = 'Feedback';
    logInScreen = <Feedback clickBack={clickBack} width={width*0.8}/>
  }else if (aScreen.t === 'showUserTable'){
    logInScreen = <UserTable width={width*0.8} userDatabaseId={aScreen.userDatabaseId} userTableId={aScreen.userTableId} programSetID={programSetID} sessionID={sessionID} signKey={signKey} userID={userID}/>
  }else if (aScreen.t === 'functionDetails'){
    title = aScreen.title;
    logInScreen = <FunctionDetails clickBack={clickBack} textList={aScreen.v} width={width*0.8}/>
  }else if (aScreen.t === 'srcSelector'){
    logInScreen = <SrcSelector srcPath={aScreen.path} isNew={aScreen.isNew} currentList={currentList} organicChanges={organicChanges} columnWidth={width*0.8} signKey={signKey} isFromScreen={aScreen.isFromScreen} userID={userID} sessionID={sessionID} clickBack={clickBack} setItemEdited={setItemEdited} userNos={userNos} setIsShowingSomeDropDown={setIsShowingSomeDropDown} hidePanelRelativeItems={hidePanelRelativeItems} setHidePanelRelativeItems={setHidePanelRelativeItems}/>
  }else if (aScreen.t === 'elementSelector'){
    logInScreen = <ElementSelector chains={chains} itemT={aScreen.itemT} feedSource={aScreen.n} addPath={aScreen.addPath} position={aScreen.position} insetWidth={aScreen.insetWidth} insetHeight={aScreen.insetHeight} currentList={currentList} organicChanges={organicChanges} clickBack={clickBack} setItemEdited={setItemEdited} userNos={userNos} doingWhat={doingWhat} setDoingWhat={setDoingWhat} width={width*0.9} height={height*0.9} userID={userID} signKey={signKey} sessionID={sessionID} setIsClickingOnContentDiv={setIsClickingOnContentDiv} refObject={refObject} setIsShowingSomeDropDown={setIsShowingSomeDropDown} hidePanelRelativeItems={hidePanelRelativeItems} setHidePanelRelativeItems={setHidePanelRelativeItems} changeTab={changeTab} palette={palette}/>
  }else if (aScreen.t === 'categorySelector'){
    logInScreen = <CategorySelector chains={chains} programSetID={programSetID} itemT={aScreen.itemT} addPath={aScreen.addPath} position={aScreen.position} insetWidth={aScreen.insetWidth} insetHeight={aScreen.insetHeight} currentList={currentList} organicChanges={organicChanges} clickBack={clickBack} setItemEdited={setItemEdited} userNos={userNos} doingWhat={doingWhat} setDoingWhat={setDoingWhat} width={width*0.9} userID={userID} signKey={signKey} sessionID={sessionID} setIsClickingOnContentDiv={setIsClickingOnContentDiv} refObject={refObject} setIsShowingSomeDropDown={setIsShowingSomeDropDown} hidePanelRelativeItems={hidePanelRelativeItems} setHidePanelRelativeItems={setHidePanelRelativeItems} changeTab={changeTab} itemCategories={itemCategories} addToExtraScreen={addToExtraScreen} centerZoom={centerZoom}/>
  }else if (aScreen.t === 'pagePopUpSelector'){
    logInScreen = <PagePopUpSelector chains={chains} previousDApps={aScreen.previousDApps} isFEOrPU={aScreen.itemT} feedSource={aScreen.n} insetWidth={aScreen.insetWidth} insetHeight={aScreen.insetHeight} currentList={currentList} organicChanges={organicChanges} clickBack={clickBack} setItemEdited={setItemEdited} userNos={userNos} overallWidth={width} width={width*0.8} height={height*0.9} userID={userID} signKey={signKey} sessionID={sessionID} centerZoom={centerZoom} changeTab={changeTab} palette={palette} colorCombo={colorCombo} setColorCombo={setColorCombo} customColorRecord={customColorRecord} setCustomColorRecord={setCustomColorRecord} isShowingCustom={isShowingCustom} setIsShowingCustom={setIsShowingCustom}  />

  }else if (aScreen.t === 'signIn'){
    title = 'Sign In';

    logInScreen = <AskToSignInPage reallySignIn={reallySignIn} randomCode={randomCode} responseGoogleYes={responseGoogleYes} width={width*0.8} chains={chains} userID={userID}/>
  }else if (aScreen.t === 'credits'){
    title = 'Credits';

    logInScreen = <AddCredits chains={chains} width={width*0.8} userID={userID} sessionID={sessionID} signKey={signKey} setNosCredits={setNosCredits} nosCredits={nosCredits}  requirements={aScreen.v}/>


  }else if (aScreen.t === 'templates'){
    // title = 'Preview Template';
    logInScreen = <SelectTemplates chains={chains} overallWidth={width} width={width*0.8} height={height*0.9} templates={aScreen.v} currentSelection={aScreen.i} changeTab={changeTab} selectNew={selectNew} palette={palette}/>
  }else if (aScreen.t === 'existingSmartContractsOfChain'){
    title = 'Select from existing smart contracts';
    logInScreen = <SelectExistingContracts width={width*0.8} currentList={currentList} userID={userID} sessionID={sessionID} signKey={signKey} setTempAddr={setTempAddr} clickBack={clickBack} />
  }else if (aScreen.t === 'guideScreen'){
    title = 'Guide';
    logInScreen = <GuideScreen width={width} set={aScreen.set}/>
  }else if (currentList){
    
    if (aScreen.t === 'responsiveEdit'){
      overflowY = 'none';
      var clickBackHere = clickBack;
      logInScreen = <ResponsiveEditor chains={chains} path={aScreen.path} currentList={currentList} clickBack={clickBackHere}  organicChanges={organicChanges} postFn={updateFns['a1_'+whichPopup]} addToExtraScreen={addToExtraScreen} userNos={userNos}  width={width*0.8} height={heightUsed - 50} title={aScreen.title} logInState={logInState}/>
    }else if (aScreen.t === 'sharingStatus'){
      title = 'Edit Rights';
      logInScreen = <SharingStatus logInState={logInState} width={width*0.8} sessionID={sessionID} signKey={signKey} userID={userID} programSetID={programSetID} addToExtraScreen={addToExtraScreen} setAccessLevel={setAccessLevel}/>
    }
  }

//
  function absorbClick(e){
    e.stopPropagation();
  }

  var titleLine;
  var titleDiv;
  if (title){
    titleDiv = <div><br/></div>
//    
    titleLine = <span style={{color:'black', fontSize:'1.5em', fontWeight:'bolder', whiteSpace:'nowrap'}}>{title}</span>
  }
//
  var clickBackButton = <NormalIcon onClick={clickBack} icon='eva:close-fill' />
//

  function onMouseDown(e){
    e.stopPropagation();
  }

  function onClickX(e){
    e.stopPropagation();
  }

  return <table key={0} style={popUpStyle} onMouseDown={onMouseDown} onClick={onClickX} ><tbody>
        <tr onClick={clickBack}>
          <td width='50%'><div style={{height}}></div></td>
          <td >
            <div width='100%' onClick={absorbClick} style={{backgroundColor:'white', height:heightUsed, overflowY, padding}} align='right'>
              {clickBackButton}
              <center>
                {titleLine}
                {titleDiv}
                {logInScreen}
              </center>
            </div>
          </td>
          <td width='50%' ></td>
          </tr>
          </tbody>
      </table>  
}
